module.exports = __webpack_public_path__ + "build/desktop/img/disabledSvg.effee7450206d4f8ee091b1aaf8a9258.svg";